export default {
  // ── Navigation ──────────────────────────────────────────────────────────────
  'nav.dashboard':         'לוח בקרה',
  'nav.leads':             'לידים',
  'nav.filters':           'סינון',
  'nav.filters/keywords':  'מילות מפתח',
  'nav.filters/prompts':   'פרומפטים',
  'nav.groups':            'קבוצות',
  'nav.history':           'היסטוריית סריקות',
  'nav.settings':          'הגדרות',
  'nav.users':             'משתמשים',

  // ── Sidebar status ──────────────────────────────────────────────────────────
  'sidebar.sweeping':  'סורק…',
  'sidebar.running':   'פעיל',
  'sidebar.paused':    'מושהה',
  'sidebar.runSweep':  'הפעלת סריקה',
  'sidebar.logout':    'יציאה',

  // ── Sweep modal ─────────────────────────────────────────────────────────────
  'sweep.title':              '⚡ הפעל סריקה',
  'sweep.subtitle':           'בחרו כמה אחורה לסרוק',
  'sweep.last_sweep.label':   'מאז הסריקה האחרונה',
  'sweep.last_sweep.sub':     'פוסטים חדשים בלבד מאז הריצה הקודמת',
  'sweep.last_day.label':     '24 שעות אחרונות',
  'sweep.last_day.sub':       'פוסטים מהיממה האחרונה',
  'sweep.last_3_days.label':  '3 ימים אחרונים',
  'sweep.last_3_days.sub':    'פוסטים מ-3 הימים האחרונים',
  'sweep.amount.label':       'לפי מספר פוסטים',
  'sweep.amount.sub':         'סרוק מספר קבוע של פוסטים אחרונים',
  'sweep.postsPerGroup':      'מספר פוסטים לקבוצה',
  'sweep.postsPlaceholder':   'לדוגמה 50',
  'sweep.run':                '⚡ הפעלת סריקה',
  'sweep.cancel':             'ביטול',

  // ── Time range ──────────────────────────────────────────────────────────────
  'time.24h':  '24 שעות',
  'time.7d':   '7 ימים',
  'time.30d':  '30 ימים',
  'time.all':  'הכל',

  // ── Shared primitives ───────────────────────────────────────────────────────
  'loading':           'טוען…',
  'add':               '+ הוספה',
  'save':              'שמירה',
  'cancel':            'ביטול',
  'delete':            'מחיקה',
  'edit':              '✏️ עריכה',
  'saving':            'שמירה…',
  'copied':            'הועתק!',
  'apiNotice':         'ה-API לא מחובר — מוצגים ערכי ברירת מחדל.',
  'goToPost':          'לפוסט',
  'relevant.title':    'רלוונטי',
  'notRelevant.title': 'לא רלוונטי',

  // ── Dashboard ───────────────────────────────────────────────────────────────
  'dashboard.title':           'לוח בקרה',
  'dashboard.subtitle':        'מודיעין לידים בזמן אמת מקבוצות פייסבוק',
  'dashboard.postsScanned':    'פוסטים נסרקו',
  'dashboard.qualifiedLeads':  'לידים רלוונטיים',
  'dashboard.pendingSend':     'ממתין לשליחה',
  'dashboard.sentToday':       'נשלח היום',
  'dashboard.aiCosts':         'עלות AI',
  'dashboard.avgScore':        'ציון ממוצע',
  'dashboard.scoreBreakdown':  'פילוח ציונים',
  'dashboard.relevanceFeedback': 'משוב רלוונטיות',
  'dashboard.assignmentOverview': 'סקירת שיוך',
  'dashboard.quickStats':      'סטטיסטיקה מהירה',
  'dashboard.recentLeads':     'לידים אחרונים',
  'dashboard.scoreHigh':       '🟢 גבוה 80+',
  'dashboard.scoreMid':        '🟡 בינוני 65–79',
  'dashboard.scoreLow':        '⚪ נמוך <65',
  'dashboard.noScoreData':     'אין נתוני ציונים עדיין',
  'dashboard.relevant':        '👍 רלוונטי',
  'dashboard.notRelevant':     '👎 לא רלוונטי',
  'dashboard.untagged':        '❓ ללא תיוג',
  'dashboard.positiveRate':    'שיעור חיובי:',
  'dashboard.needsReview':     '{n} לידים ממתינים לסקירה',
  'dashboard.unassigned':      'לא משויך',
  'dashboard.assigned':        'משויך',
  'dashboard.noLeadsAssigned': 'אין לידים משויכים עדיין',
  'dashboard.scoreHighFull':   '🟢 ציון גבוה (80+)',
  'dashboard.scoreMidFull':    '🟡 ציון בינוני (65–79)',
  'dashboard.sentTodayFull':   '📤 נשלח היום',
  'dashboard.pendingSendFull': '📋 ממתין לשליחה',
  'dashboard.noLeads':         'אין לידים עדיין — הפעילו סריקה כדי להתחיל',

  // ── Table column headers ────────────────────────────────────────────────────
  'col.score':      'ציון',
  'col.author':     'מחבר',
  'col.group':      'קבוצה',
  'col.date':       'תאריך',
  'col.status':     'סטטוס',
  'col.type':       'סוג',
  'col.preview':    'תצוגה מקדימה',
  'col.relevant':   'רלוונטי',
  'col.keyword':    'מילת מפתח',
  'col.category':   'קטגוריה',
  'col.blocked':    'חסום',
  'col.posts':      'פוסטים',
  'col.signal':     'אות',
  'col.created':    'נוצר',
  'col.active':     'פעיל',
  'col.email':      'אימייל',
  'col.name':       'שם',
  'col.phone':      'טלפון',
  'col.role':       'תפקיד',
  'col.lastLogin':  'כניסה אחרונה',
  'col.started':    'התחלה',
  'col.duration':   'משך',
  'col.triggered':  'הפעלה',
  'col.postsSeen':  'פוסטים שנראו',
  'col.matched':    'התאמות',
  'col.scored':     'ניקוד',
  'col.newLeads':   'לידים חדשים',
  'col.aiCost':     'עלות AI',

  // ── Lead detail labels ──────────────────────────────────────────────────────
  'lead.sent':             '✓ נשלח',
  'lead.pending':          'ממתין',
  'lead.comment':          '💬 תגובה',
  'lead.post':             '📝 פוסט',
  'lead.fullComment':      '💬 תגובה מלאה',
  'lead.fullPost':         '📝 פוסט מלא',
  'lead.aiContext':        '💡 הקשר AI',
  'lead.pitchDraft':       '✉️ טיוטת פיץ׳',
  'lead.matchedKeywords':  '🔑 מילות מפתח שהתאימו',
  'lead.aiPrompt':         '✦ פרומפט AI',
  'lead.context':          '💡 הקשר',
  'lead.viewMore':         '▼ הצג עוד',
  'lead.viewLess':         '▲ הצג פחות',

  // ── Leads tab ───────────────────────────────────────────────────────────────
  'leads.title':           'לידים',
  'leads.subtitle':        '{n} לידים',
  'leads.exportCsv':       '⬇ ייצוא CSV',
  'leads.viewList':        '☰ רשימה',
  'leads.viewGrid':        '⊞ כרטיסים',
  'leads.filterTimeframe': 'טווח זמן',
  'leads.filterMinScore':  'ציון מינימלי',
  'leads.filterRelevance': 'רלוונטיות',
  'leads.filterSort':      'מיון',
  'leads.filterAssignedTo':'משויך אל',
  'leads.all':             'הכל',
  'leads.unassigned':      'לא משויך',
  'leads.relevant':        '👍 רלוונטי',
  'leads.notRelevant':     '👎 לא רלוונטי',
  'leads.untagged':        '❓ ללא תיוג',
  'leads.newestFirst':     'חדש לישן',
  'leads.oldestFirst':     'ישן לחדש',
  'leads.assign':          '👤 שיוך:',
  'leads.unassignedOption':'— לא משויך —',
  'leads.noLeads':         'אין לידים עדיין — הפעילו סריקה כדי להתחיל',
  'leads.noExport':        'אין לידים לייצוא',
  'leads.exported':        '{n} לידים יוצאו',
  'leads.assignedTo':      'שויך אל {email}',
  'leads.unassignedDone':  'שיוך הוסר',
  'leads.failedAssign':    'שגיאה: {msg}',
  'leads.failedUpdate':    'עדכון נכשל: {msg}',

  // ── CSV headers ─────────────────────────────────────────────────────────────
  'csv.author':          'מחבר',
  'csv.group':           'קבוצה',
  'csv.score':           'ציון',
  'csv.date':            'תאריך',
  'csv.matchedKeywords': 'מילות מפתח שהתאימו',
  'csv.aiContext':       'הקשר AI',
  'csv.pitchDraft':      'טיוטת פיץ׳',
  'csv.relevant':        'רלוונטי',
  'csv.alertSent':       'התראה נשלחה',
  'csv.postUrl':         'קישור לפוסט',
  'csv.yes':             'כן',
  'csv.no':              'לא',
  'csv.untagged':        'ללא תיוג',

  // ── Keywords ────────────────────────────────────────────────────────────────
  'keywords.title':             'מילות מפתח',
  'keywords.subtitleInclude':   'פוסטים שמתאימים לפחות למילת מפתח אחת נשלחים לניקוד',
  'keywords.subtitleExclude':   'פוסטים שמתאימים למילת החרגה מסוננים לפני הניקוד',
  'keywords.tabInclude':        'כלול',
  'keywords.tabExclude':        'הסתר',
  'keywords.searchGuide':       'מדריך חיפוש',
  'keywords.guideExact':        'ביטוי מדויק',
  'keywords.guideBoth':         'שתי מילים',
  'keywords.guideStem':         'שורש מילה',
  'keywords.guideExactResult':  'התאמות מדויקות בלבד',
  'keywords.guideBothResult':   'שתי המילים בכל מקום',
  'keywords.guideStemResult':   'כל צורות המילה',
  'keywords.searchPlaceholder': 'חפש מילות מפתח',
  'keywords.allOn':             '⏻ הכל פעיל',
  'keywords.allOff':            '⏻ הכל כבוי',
  'keywords.recalibrate':       '⟳ כיול מחדש',
  'keywords.recalibrating':     '…',
  'keywords.placeholderInclude':'מילת מפתח חדשה (למשל מחפש+כלי)',
  'keywords.placeholderExclude':'תבנית החרגה (למשל דרוש )',
  'keywords.emptyInclude':      'אין מילות מפתח עדיין — הוסיפו אחת למעלה',
  'keywords.emptyExclude':      'אין מילות החרגה עדיין — הוסיפו אחת למעלה',
  'keywords.added':             'מילת מפתח נוספה!',
  'keywords.excludeAdded':      'מילת החרגה נוספה!',
  'keywords.deleted':           'מילת מפתח נמחקה',
  'keywords.recalibratedMsg':   'נתוני האות כויילו מחדש — {n} מילות מפתח עם נתונים',

  // ── AI Prompts ──────────────────────────────────────────────────────────────
  'prompts.title':               'פרומפטים של AI',
  'prompts.subtitle':            'הנחה את שיקול הניקוד של Claude — רק פרומפט אחד פעיל בכל פעם',
  'prompts.anthropicTitle':      'חיבור Anthropic API',
  'prompts.anthropicSubtitle':   'חבר את חשבון Anthropic שלך כדי להפעיל ניקוד לידים מבוסס AI',
  'prompts.connected':           '✓ מחובר',
  'prompts.notConnected':        'לא מחובר',
  'prompts.currentKey':          'מפתח נוכחי:',
  'prompts.updateApiKey':        'עדכון מפתח API',
  'prompts.apiKey':              'מפתח API',
  'prompts.saveKey':             'שמירת מפתח',
  'prompts.model':               'מודל',
  'prompts.scoringTitle':        'פרומפטים לניקוד',
  'prompts.activePrompt':        'פעיל: {name}',
  'prompts.noActivePrompt':      'אין פרומפט פעיל — מצב מילות מפתח בלבד',
  'prompts.active':              'פעיל',
  'prompts.on':                  'פעיל',
  'prompts.off':                 'כבוי',
  'prompts.newPromptPlaceholder':'שם הפרומפט',
  'prompts.promptTextPlaceholder':'כתוב הוראות ניקוד עבור Claude...',
  'prompts.savePlus':            '+ שמירה',
  'prompts.addNew':              '+ פרומפט חדש',
  'prompts.saved':               'הגדרות Anthropic נשמרו!',
  'prompts.updated':             'הפרומפט עודכן',
  'prompts.deleted':             'הפרומפט נמחק',
  'prompts.created':             'הפרומפט נוצר',
  'prompts.recommended':         'מומלץ',
  'prompts.fastest':             'מהיר ביותר',
  'prompts.copyKey':             'העתק מפתח',
  'prompts.hideKey':             'הסתר מפתח',
  'prompts.showKey':             'הצג מפתח',
  'prompts.failedReveal':        'לא ניתן לחשוף את המפתח',
  'prompts.failedCopy':          'לא ניתן להעתיק את המפתח',

  // ── Groups ──────────────────────────────────────────────────────────────────
  'groups.title':              'קבוצות פייסבוק',
  'groups.subtitle':           'נהל אילו קבוצות Lead Radar סורק בכל ריצה',
  'groups.fbNotConnected':     'פייסבוק לא מחובר',
  'groups.fbNotConnectedDesc': 'לחצו לפתיחת דפדפן ולהתחברות לפייסבוק. הסשן נשמר וישמש בכל הסריקות הבאות.',
  'groups.waitingForLogin':    'ממתין להתחברות…',
  'groups.connectFacebook':    '🔗 חיבור פייסבוק',
  'groups.sessionActive':      'סשן פייסבוק פעיל',
  'groups.activeGroups':       'קבוצות פעילות',
  'groups.activePaused':       '{active} פעילות · {paused} מושהות',
  'groups.noGroups':           'לא נוספו קבוצות עדיין',
  'groups.openLink':           '↗ פתח',
  'groups.addNew':             '+ הוסף קבוצה חדשה',
  'groups.addNewSub':          'הדביקו קישור לקבוצת פייסבוק כדי להתחיל לסרוק אותה',
  'groups.labelPlaceholder':   'תווית',
  'groups.urlPlaceholder':     'https://www.facebook.com/groups/...',
  'groups.addButton':          '+ הוספת קבוצה',
  'groups.removed':            'הקבוצה הוסרה',
  'groups.added':              'הקבוצה נוספה!',
  'groups.invalidUrl':         'כתובת קבוצת פייסבוק לא תקינה',
  'groups.loginOpening':       'פותח דפדפן להתחברות לפייסבוק — התחבר והחלון ייסגר אוטומטית.',
  'groups.sessionSaved':       'סשן פייסבוק נשמר!',
  'groups.loginTimeout':       'פג זמן ההתחברות',
  'groups.scraperError':       'לא ניתן להגיע ל-Scraper',

  // ── Settings ────────────────────────────────────────────────────────────────
  'settings.title':               'הגדרות',
  'settings.subtitle':            'קבע תזמון סריקות, התראות ודוחות יומיים',
  'settings.sweepScheduling':     '⏱ תזמון סריקות',
  'settings.sweepSchedulingSub':  'כמה פעמים Lead Radar סורק קבוצות פייסבוק',
  'settings.schedulerEnabled':    '🟢 סריקות אוטומטיות מופעלות',
  'settings.schedulerDisabled':   '⏸ סריקות אוטומטיות מושבתות',
  'settings.schedulerEnabledDesc':'Lead Radar יסרוק קבוצות אוטומטית לפי לוח הזמנים שלהלן',
  'settings.schedulerDisabledDesc':'המתזמן מושהה — השתמש בכפתור הפעל סריקה לסריקה ידנית',
  'settings.scanEvery':           'סרוק כל',
  'settings.every':               'כל',
  'settings.minutes':             'דקות',
  'settings.hours':               'שעות',
  'settings.days':                'ימים',
  'settings.sweepScope':          '🔭 טווח סריקה אוטומטית',
  'settings.sweepScopeSub':       'כמה אחורה כל סריקה מתוזמנת מסתכלת',
  'settings.postsPerGroup':       'פוסטים לקבוצה',
  'settings.instantAlerts':       '⚡ התראות מיידיות',
  'settings.instantAlertsSub':    'מופעלות מיידית כשפוסט מקבל ציון מעל הסף',
  'settings.scoreThreshold':      'סף ציון',
  'settings.alertWhenScore':      'שלח התראה מיידית כשציון ≥ {threshold}',
  'settings.sendTestEmail':       '📧 שליחת אימייל בדיקה',
  'settings.sendUnsent':          '📤 שליחת התראות שלא נשלחו',
  'settings.sendUnsentDesc':      'שלח התראות על כל הלידים מעל הסף שטרם נשלחו',
  'settings.dailyReport':         '📋 דוח יומי',
  'settings.dailyReportSub':      'סיכום מדורג של כל הלידים — נשלח פעם ביום',
  'settings.sendTime':            'זמן שליחה',
  'settings.next':                'הבא:',
  'settings.reportRecipients':    'נמעני הדוח',
  'settings.aiOutputLang':        '🌐 שפת פלט AI',
  'settings.aiOutputLangSub':     'שפה לטקסט הקשר ופיץ׳ שנוצרים על ידי AI',
  'settings.saveAll':             '💾 שמירת ההגדרות',
  'settings.changePassword':      '🔑 שינוי סיסמה',
  'settings.changePasswordSub':   'עדכן את סיסמת הכניסה שלך',
  'settings.currentPassword':     'סיסמה נוכחית',
  'settings.newPassword':         'סיסמה חדשה',
  'settings.confirmPassword':     'אשר סיסמה חדשה',
  'settings.passwordHint':        'מינימום 10 תווים · אות גדולה אחת · ספרה אחת',
  'settings.updatePassword':      'עדכון סיסמה',
  'settings.saved':               '✅ ההגדרות נשמרו!',
  'settings.savedLocally':        'נשמר מקומית — ה-API לא מחובר',
  'settings.fillBothFields':      'מלא את שני השדות',
  'settings.passwordMismatch':    'הסיסמאות החדשות אינן תואמות',
  'settings.passwordChanged':     'הסיסמה שונתה בהצלחה',
  'settings.passwordChangeFailed':'שינוי הסיסמה נכשל',
  'settings.emailAddresses':      '📧 כתובות אימייל',
  'settings.noEmails':            'לא נוספו כתובות אימייל עדיין',
  'settings.invalidEmail':        'כתובת אימייל לא תקינה',
  'settings.emailAlreadyAdded':   'כבר נוסף',
  'settings.emailAdded':          'אימייל נוסף!',
  'settings.emailPlaceholder':    'name@company.com',
  'settings.langHebrew':          '🇮🇱 עברית',
  'settings.langEnglish':         '🇬🇧 אנגלית',
  'settings.langPolish':          '🇵🇱 פולנית',
  'settings.testEmailSent':       'אימייל בדיקה נשלח אל {recipients}',
  'settings.unsentAlertsSent':    '{n} התראות נשלחו (סף ≥{threshold})',

  // ── Sweep history ───────────────────────────────────────────────────────────
  'history.title':           'היסטוריית סריקות',
  'history.subtitle':        'כל ריצות הסריקה — {n} סה״כ',
  'history.totalPostsSeen':  '📬 סה״כ פוסטים שנראו',
  'history.totalLeads':      '🎯 סה״כ לידים שנמצאו',
  'history.totalCost':       '💡 סה״כ עלות AI',
  'history.manual':          'ידני',
  'history.scheduler':       'מתזמן',
  'history.completed':       '✓ הושלמה',
  'history.failed':          '✗ נכשלה',
  'history.partial':         '⚠ חלקית',
  'history.running':         '⟳ בריצה',
  'history.noSweeps':        'אין סריקות עדיין — הפעילו אחת כדי לראות היסטוריה',

  // ── Login ────────────────────────────────────────────────────────────────────
  'login.title':              'Pulseem Lead Radar',
  'login.signIn':             'כניסה לחשבון',
  'login.smsVerification':    'אימות SMS',
  'login.emailVerification':  'אימות אימייל',
  'login.email':              'אימייל',
  'login.password':           'סיסמה',
  'login.signingIn':          'כניסה…',
  'login.signInBtn':          'כניסה',
  'login.captchaRequired':    'אנא השלם את ה-CAPTCHA',
  'login.invalidCredentials': 'אימייל או סיסמה שגויים',
  'login.otpSentPhone':       'קוד בן 6 ספרות נשלח לטלפון שלך. הזן אותו למטה להשלמת הכניסה.',
  'login.otpSentEmail':       'קוד בן 6 ספרות נשלח אל {email}. הזן אותו למטה להשלמת הכניסה.',
  'login.verificationCode':   'קוד אימות',
  'login.verifying':          'מאמת…',
  'login.verifyBtn':          'אימות קוד',
  'login.backToLogin':        'חזרה לכניסה',
  'login.resendIn':           'שליחה מחדש בעוד {n} שניות',
  'login.resend':             'שליחת קוד מחדש',
  'login.tooManyAttempts':    'יותר מדי ניסיונות. אנא התחבר מחדש.',
  'login.serverError':        'לא ניתן להתחבר לשרת',
  'login.resendError':        'לא ניתן לשלוח קוד מחדש',

  // ── Verify page ──────────────────────────────────────────────────────────────
  'verify.title':           'ברוך הבא ל-Lead Radar',
  'verify.subtitle':        'הגדר שם וסיסמה כדי להתחיל',
  'verify.accountReady':    'החשבון מוכן!',
  'verify.canNowSignIn':    'כעת תוכל להתחבר עם האימייל והסיסמה שלך.',
  'verify.goToLogin':       'לדף הכניסה',
  'verify.yourName':        'שמך',
  'verify.namePlaceholder': 'שם פרטי ומשפחה',
  'verify.password':        'סיסמה',
  'verify.passwordPlaceholder': 'מינימום 10 תווים, אות גדולה, ספרה',
  'verify.confirmPassword': 'אשר סיסמה',
  'verify.settingUp':       'מגדיר חשבון…',
  'verify.createAccount':   'יצירת חשבון',
  'verify.enterName':       'אנא הזן את שמך',
  'verify.passwordMismatch':'הסיסמאות אינן תואמות',
  'verify.invalidLink':     'קישור לא תקין או שפג תוקפו',
  'verify.serverError':     'לא ניתן להתחבר לשרת',

  // ── Users ────────────────────────────────────────────────────────────────────
  'users.title':          'משתמשים',
  'users.otpMethod':      'שיטת OTP:',
  'users.otpEmail':       '✉️ אימייל',
  'users.otpSms':         '📱 SMS',
  'users.inviteNew':      'הזמן משתמש חדש',
  'users.emailPlaceholder':'כתובת אימייל',
  'users.admin':          'מנהל',
  'users.sendInvite':     'שליחת הזמנה',
  'users.editUser':       'ערוך משתמש',
  'users.name':           'שם',
  'users.phone':          'טלפון',
  'users.fullName':       'שם מלא',
  'users.phoneNumber':    'מספר טלפון',
  'users.setPassword':    'קבע סיסמה',
  'users.newPassword':    'סיסמה חדשה',
  'users.setPasswordBtn': 'קביעת סיסמה',
  'users.roleAdmin':      'מנהל',
  'users.roleUser':       'משתמש',
  'users.verified':       '✓ מאומת',
  'users.pending':        '⏳ ממתין',
  'users.editBtn':        '✏ עריכה',
  'users.removeAdmin':    'הסר הרשאת מנהל',
  'users.makeAdmin':      'הפוך למנהל',
  'users.deleteBtn':      'מחק',
  'users.otpSetTo':       'שיטת OTP הוגדרה ל-{method}',
  'users.inviteSent':     'הזמנה נשלחה אל {email}',
  'users.updated':        'המשתמש עודכן',
  'users.deleted':        'המשתמש נמחק',
  'users.confirmDelete':  'למחוק את המשתמש {email}?',
  'users.passwordUpdated':'הסיסמה עודכנה עבור {email}',

  // ── App-level ────────────────────────────────────────────────────────────────
  'app.sweepComplete':   '✅ הסריקה הושלמה — {n} לידים חדשים!',
  'app.sweepInProgress': 'סריקה כבר מתבצעת',
  'app.sweepFailed':     'הסריקה נכשלה: {msg}',

  // ── Language toggle ──────────────────────────────────────────────────────────
  'lang.he': 'עברית',
  'lang.en': 'EN',
};
